import React, { useState } from "react";
import Cookies from 'js-cookie';

const LoginToken = ({ history }) => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  Cookies.set('token', token, { expires: 1, path: '/'});
  console.log("token: ", token); // "abc123"
  history.push("/download-leads");

  return (
    <>
    </>
  );
};

export default LoginToken;
